import { QueryReturnValue } from '@reduxjs/toolkit/dist/query/baseQueryTypes';
import {
  BaseQueryApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from '@reduxjs/toolkit/query';
import { useNavigate } from 'react-router-dom';
import { User, UserRole } from '../models/auth';
import { useLogoutMutation } from './auth';

export const tokenKey = 'token';

export const fetchQueryWithToken = async (
  args: string | FetchArgs,
  api: BaseQueryApi,
  extraOptions: Record<string, unknown>,
): Promise<QueryReturnValue<unknown, FetchBaseQueryError, FetchBaseQueryMeta>> => {
  const baseQuery = fetchBaseQuery({
    prepareHeaders: (headers: Headers) => {
      const token = localStorage.getItem(tokenKey);
      if (token) headers.set('Authorization', `Bearer ${token}`);
      return headers;
    },
  });
  const response = await baseQuery(args, api, extraOptions);
  if (api.endpoint !== 'login' && response?.error?.status === 401) {
    localStorage.removeItem(tokenKey);
    location.reload();
  }
  return response;
};

export const useLogout = () => {
  const navigate = useNavigate();
  const [logout] = useLogoutMutation();

  return async () => {
    try {
      await logout().unwrap();
    } catch (e) {
      console.error('Error on logout', e);
    } finally {
      localStorage.removeItem(tokenKey);
      navigate(0);
    }
  };
};

export const hasAdminRole = (user?: User): boolean => user?.role === UserRole.Admin;
